"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var locales = _interopRequireWildcard(require("date-fns/locale"));
var _moment = _interopRequireDefault(require("moment"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _clickAway = require("../../utils/click-away");
var _Input = require("../Input");
require("react-datepicker/dist/react-datepicker.css");
require("./custom-datepicker-style.css");
var _DatePickerModule = _interopRequireDefault(require("./DatePicker.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // $FlowFixMe[untyped-import]
// $FlowFixMe[untyped-import]
// $FlowFixMe[untyped-import]
const DatePicker = _ref => {
  let {
    locale = 'en',
    value,
    onChange,
    classNames,
    allowCalendarToggleOnIconClick = false,
    datePickerProps,
    inputProps,
    pickerType,
    clickAwayRef
  } = _ref;
  const {
    placeholder,
    type,
    ...restInputProps
  } = inputProps || {};

  // --- Picker Type Config ---
  const getReactDatePickerPropsForPickerType = () => {
    switch (pickerType) {
      case 'date':
        return {
          dateFormat: 'dd/MM/yyyy',
          popperPlacement: 'bottom',
          ...datePickerProps
        };
      case 'time':
        return {
          dateFormat: 'HH:mm',
          popperPlacement: 'bottom',
          showTimeSelect: true,
          showTimeCaption: false,
          showTimeSelectOnly: true,
          timeIntervals: 15,
          ...datePickerProps
        };
      case 'date-time':
        return {
          dateFormat: 'dd/MM/yyyy HH:mm',
          popperPlacement: 'bottom',
          showTimeSelect: true,
          timeCaption: '',
          timeIntervals: 1,
          ...datePickerProps
        };
      case 'week':
        return {
          dateFormat: 'w, YYYY',
          popperPlacement: 'bottom',
          selectWeek: true,
          showWeekNumbers: true,
          showWeekPicker: true,
          ...datePickerProps
        };
      case 'month':
        return {
          dateFormat: 'MMMM yyyy',
          popperPlacement: 'bottom',
          showMonthYearPicker: true,
          showMonthYearPickerOnly: true,
          ...datePickerProps
        };
      default:
        return {};
    }
  };

  // To convert date to YYYY-MM-DD format
  const formatDateToYMD = dateStr => (0, _moment.default)(dateStr).format('YYYY-MM-DD');

  // To convert time to HH:mm format
  const formatTimeToHM = dateStr => (0, _moment.default)(dateStr).format('HH:mm');

  // To combine date and time in IST format
  const combineDateTimeInISO = (datePart, timePart) => {
    if (!datePart || !timePart) {
      return null;
    }
    // Date part is in DD/MM/YYYY format, convert it to YYYY-MM-DD format
    const datePartInYYYYMMDD = datePart.split('/').reverse().join('-');
    const isoString = `${datePartInYYYYMMDD}T${timePart}:00+05:30`;
    return new Date(isoString);
  };

  // To format the value based on the pickerType
  const formatPickerValue = value => {
    if (value === '') {
      return null;
    }
    if (pickerType === 'date') {
      return combineDateTimeInISO(value, '00:00');
    }
    if (pickerType === 'time') {
      return combineDateTimeInISO(formatDateToYMD(new Date()), value || '00:00');
    }
    if (pickerType === 'date-time') {
      return combineDateTimeInISO(value.split(' ')[0], value.split(' ')[1]);
    }
    return '';
  };
  const [localValue, setLocalValue] = React.useState(formatPickerValue(value));
  React.useEffect(() => {
    if (localValue === '') {
      setLocalValue(null);
    }
  }, [localValue]);

  // Register locale for date-fns
  (0, _reactDatepicker.registerLocale)(locale, locales[locale]);

  // To handle the value change
  const handleValueChange = value => {
    setLocalValue(value);
    if (pickerType === 'date') {
      onChange(formatDateToYMD(value));
    } else if (pickerType === 'time') {
      onChange(formatTimeToHM(value));
    } else if (pickerType === 'date-time') {
      onChange(`${formatDateToYMD(value)}T${formatTimeToHM(value)}`);
    } else {
      onChange(value);
    }
  };
  return /*#__PURE__*/React.createElement(_clickAway.ClickAway, {
    clickAwayRef: clickAwayRef
  }, _ref2 => {
    let {
      isOpen,
      onOpen,
      boundaryRef,
      triggerRef
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      ref: boundaryRef,
      className: (0, _classify.default)(_DatePickerModule.default.wrapper, classNames?.wrapper)
    }, /*#__PURE__*/React.createElement(_reactDatepicker.default, _extends({}, getReactDatePickerPropsForPickerType(), {
      popperPlacement: datePickerProps?.popperPlacement || 'bottom',
      selected: localValue,
      open: isOpen,
      onChange: handleValueChange,
      onClickOutside: e => {
        e.stopPropagation();
        onOpen();
      },
      locale: locale,
      placeholderText: placeholder,
      wrapperClassName: (0, _classify.default)(_DatePickerModule.default.datePickerWrapper, datePickerProps?.wrapperClassName),
      disabled: inputProps?.disabled,
      popperClassName: datePickerProps?.popperClassName,
      className: (0, _classify.default)(_DatePickerModule.default.datePicker, datePickerProps?.className),
      customInput: /*#__PURE__*/React.createElement(_Input.Input, _extends({}, restInputProps, {
        value: value,
        onContainerClick: e => {
          e.stopPropagation();
          onOpen();
        },
        onIconRightClick: () => {
          if (allowCalendarToggleOnIconClick) {
            onOpen();
          }
        },
        onIconLeftClick: () => {
          if (allowCalendarToggleOnIconClick) {
            onOpen();
          }
        },
        ref: triggerRef
      }))
    })));
  });
};
exports.DatePicker = DatePicker;